/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2019 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import { ccCultureID, CultureID } from './CultureID';

 /** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/** [[Local]] handler for cc.Sprite's to respond to Localization setting changes. */
@cc._decorator.ccclass('LocalAtlasData')
export default class LocalAtlasData
{
    @property(cc.SpriteAtlas)
    public Atlas: cc.SpriteAtlas = null;

    @property({ type: ccCultureID })
    public CultureId: CultureID = CultureID.en_us;
}
